import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/q2_console_clear_bg.png'
import _imports_1 from '@/assets/q2_developer_clear_bg.svg'
import _imports_2 from '@/assets/okta_generic.svg'


const _hoisted_1 = { class: "landing-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "session-banner session-banner--expired"
}
const _hoisted_3 = {
  key: 1,
  class: "session-banner session-banner--changed"
}

import { computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'


export default /*@__PURE__*/_defineComponent({
  __name: 'SelectLogin',
  setup(__props) {


const router = useRouter()
const route = useRoute()

const isSessionExpired = computed(() => route.query.reason === 'session_expired')
const isSessionChanged = computed(() => route.query.reason === 'session_changed')

function goToCorp() {
  router.push({
    path: '/corp/login',
    query: {
      redirect: route.query.redirect || '/'
    }
  })
}

function goToDeveloper() {
  router.push({
    path: '/developer/login',
    query: {
      redirect: route.query.redirect || '/'
    }
  })
}

function goToConsole() {
  router.push({
    path: '/console/login',
    query: {
      redirect: route.query.redirect || '/'
    }
  })
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isSessionExpired.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Your session has expired. Please log in again to continue. "))
      : _createCommentVNode("", true),
    (isSessionChanged.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, " A different session type was detected. You have been logged out for security. Please log in again. "))
      : _createCommentVNode("", true),
    _createElementVNode("div", { class: "landing-card" }, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "title-login" }, "Q2 Mobile Distribution Site", -1)),
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "description" }, " A centralized platform to distribute mobile apps and provide a seamless experience for downloading builds. ", -1)),
      _createElementVNode("div", { class: "login-options" }, [
        _createElementVNode("button", {
          onClick: goToConsole,
          class: "console-btn"
        }, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("div", { class: "icon-wrapper" }, [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "Q2 Console",
              class: "btn-icon"
            })
          ], -1),
          _createTextVNode(" SIGN IN WITH Q2 CONSOLE LOGIN ", -1)
        ]))]),
        _createElementVNode("button", {
          onClick: goToDeveloper,
          class: "developer-btn"
        }, [...(_cache[1] || (_cache[1] = [
          _createElementVNode("div", { class: "icon-wrapper" }, [
            _createElementVNode("img", {
              src: _imports_1,
              alt: "Q2 Developer",
              class: "btn-icon"
            })
          ], -1),
          _createTextVNode(" SIGN IN WITH Q2 DEVELOPER ", -1)
        ]))]),
        _createElementVNode("button", {
          onClick: goToCorp,
          class: "okta-btn"
        }, [...(_cache[2] || (_cache[2] = [
          _createElementVNode("div", { class: "icon-wrapper" }, [
            _createElementVNode("img", {
              src: _imports_2,
              alt: "Okta",
              class: "btn-icon btn-icon--okta"
            })
          ], -1),
          _createElementVNode("span", { class: "okta-text" }, "SIGN IN WITH Q2 OKTA", -1)
        ]))])
      ])
    ])
  ]))
}
}

})